var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dsfa-password-iframe-input",style:({ height: _vm.height })},[(!_vm.hideStandingInput)?_c('el-input',{ref:"dsfa-password-el-input",staticClass:"dsfa-password-iframe-el-input",attrs:{"placeholder":"请输入密码"}}):_vm._e(),(_vm.elInputHeight)?_c('iframe',{ref:"iframe",staticClass:"dsfa-password-iframe-input_input",style:({
      width: _vm.width,
      opacity: _vm.loaded ? 1 : 0,
    }),attrs:{"srcdoc":_vm.srcdoc,"frameborder":"0","tabindex":"0"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }